import React, { useState } from "react";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import useStyles from "./styles";

interface IProps {
  horseInjury: racehorse360.IHorseInjury;
  icon?: React.ReactNode;
  buttonClassName?: string;
}

const ViewComments = (props: IProps) => {
  const { horseInjury, icon, buttonClassName } = props;
  const classes = useStyles();

  const [popoverAnchorEl, setPopoverAnchorEl] = useState<Element>(null);

  const handlePopoverOpen = event => {
    setPopoverAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setPopoverAnchorEl(null);
  };

  return (
    <>
      <div>
        <Button
          className={clsx(classes.eidCommentsButton, buttonClassName)}
          onClick={handlePopoverOpen}
          endIcon={icon}
          disabled={!horseInjury?.comments}
        >
          View Comments
        </Button>
      </div>

      {Boolean(popoverAnchorEl) && (
        <Popover
          open
          anchorEl={popoverAnchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          classes={{
            paper: classes.popoverRoot
          }}
        >
          <Box className={classes.arrowUp} />
          <Box className={classes.popover}>
            <Box className={classes.popoverHeader}>
              {horseInjury?.incidentDate &&
                `${format(parseISO(horseInjury?.incidentDate), "M/d/yy")} `}
              EID Comments
            </Box>
            <Box className={classes.popoverContent}>
              {/*TODO: "outcomeDescription" replace with renewed back-end endpoint*/}
              {horseInjury?.comments ? horseInjury.comments : <>No Comments</>}
            </Box>
          </Box>
        </Popover>
      )}
    </>
  );
};

export default ViewComments;
